import { useEffect, useState } from "react"

import { qrCodeConfigs } from "../configs/qrCodeConfigs"
import { barCodeConfigs } from "../configs/barCodeConfigs"

import { documentTypes } from "./api/useDocuments"
import { repositoryTypes } from "./api/useRepositories"

export const outputTypes = {
    barcode: "barcode",
    qrcode: "qrcode"
}

export const scopeTypes = {
    document: "documents",
    repository: "repository"
}

export const targetTypes = {
    document: documentTypes,
    repository: repositoryTypes
}

export const getQrCodeDataUrl = () => {
    return document.getElementById(`qrcodeImg`).toDataURL()
}

export const getBarCodeDataUrl = () => {
    let selectedNodes = document.querySelectorAll('.barcodeImg');

    let data = []

    // console.log('selectedNodes', selectedNodes)

    selectedNodes.forEach(i => {
        data.push(i.toDataURL())
    })

    return data
}

export function useScanData(_outputType, _scopeType, _targetType) {

    const [scopeType, setScopeType] = useState(_scopeType)
    const [targetType, setTargetType] = useState(_targetType)
    const [outputType, setOutputType] = useState(_outputType)

    const getScanData = (props) => {

        props.outputType = outputType
        props.scopeType = scopeType;
        props.targetType = targetType

        if (outputType === outputTypes.qrcode) {

            // console.log('getQrCodeData', qrCodeConfigs())

            return qrCodeConfigs().getData(props)
        }

        if (outputType === outputTypes.barcode) {

            // console.log('getBarCodeData', barCodeConfigs())

            return barCodeConfigs().getData(props)
        }

        throw new Error(`Missing id`)

    }

    return {
        getScanData
    }
}